<template>
  <div>
    <translation-graphics
      v-model="params"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :report-type-list="reportTypeList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
      :creation-date="creation_date"
      :creation-date-trends="creation_date_trends"
      @date-change="handleDateChange"
    />

    <reports-graphics
      v-model="params"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :report-type-list="reportTypeList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
      :creation-date="creation_date"
      :creation-date-trends="creation_date_trends"
      @date-change="handleDateChange"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import moment from 'moment';

export default Vue.extend({
  name: 'OverallIndex',
  components: {
    'translation-graphics': () => import('./translations/index.vue'),
    'reports-graphics': () => import('./reports/index.vue'),
  },
  data: () => ({
    loading: true,

    textCategoryList: Array(),
    industryFieldList: Array(),
    languagesList: Array(),
    qaMethodsList: Array(),
    qaModelsList: Array(),
    reportTypeList: [{
      Name: 'All',
      type: 'all',
    }, {
      Name: 'Sucessfull',
      type: 'success',
      color: 'green',
    }, {
      Name: 'Failed',
      type: 'fail',
      color: 'red',
    }],

    params: {
      creation_date: Array(
        moment().subtract(1, 'year').format('MMM YY'),
        moment().format('MMM YY'),
      ),
      industry_field: Array(),
      doc_type: Array(),
      sourceLanguage: null,
      targetLanguage: null,
      lsp: null,
      qaModel: Array(),
      qaMethod: Array(),
      reportType: {
        Name: 'All',
        type: 'all',
      },
    },
    creation_date: Array(
      moment().subtract(1, 'year').format('MMM YY'),
      moment().format('MMM YY'),
    ),
    creation_date_trends: Array(
      moment().subtract(2, 'year').format('MMM YY'),
      moment().subtract(1, 'year').format('MMM YY'),
    ),
  }),
  methods: {
    getFilters() {
      return Promise.all([
        this.$store.dispatch('GET_LANGUAGES').then((data) => {
          this.languagesList = [...data];
          this.languagesList.unshift({
            ID: '',
            LanguageName: ' All',
            CountryISOCode: 'world',
          });
        }),
        this.$store.dispatch('GET_INDUSTRY').then((data) => {
          this.industryFieldList = [...data];
        }),
        this.$store.dispatch('GET_DOCUMENT_TYPES').then((data) => {
          this.textCategoryList = [...data];
        }),
        this.$store.dispatch('GET_QA_METHODS').then((data) => {
          this.qaMethodsList = [...data];
        }),
        Api.getEvaluationMethods().then((resp) => {
          if (resp.data.Status) {
            this.qaModelsList = [...resp.data.Data];
          }
        }),
      ]);
    },
    handleDateChange(val) {
      const newDateArr = Array();
      if (val[0] !== this.creation_date[0]) {
        newDateArr[0] = val[0];
        newDateArr[1] = moment.utc(val[0], 'MMM YY').add(1, 'year').format('MMM YY');
      } else {
        newDateArr[1] = val[1];
        newDateArr[0] = moment.utc(val[1], 'MMM YY').subtract(1, 'year').format('MMM YY');
      }
      this.creation_date = [...newDateArr];
      this.creation_date_trends = [...newDateArr.map((el) => {
        return moment.utc(el, 'MMM YY').subtract(1, 'year').format('MMM YY');
      })];
    },
  },
  created() {
    this.getFilters().then(() => {
      this.loading = false;
    });
  },
});
</script>

<style lang="scss">
  .overall-container {
    margin-bottom: 30px;
  }
  .stats-container {
    display: flex;
    flex-flow: row nowrap;
    padding: 10px 10%;

    >div {
      flex-basis: auto;
      flex-grow: 1;
      flex-shrink: 1;
    }
  }
</style>
